export const schema = {
  scenario: [{
    name: 'subAccountSetup',
    value: 'HotelCenterSubAccountSetup',
    setting: {},
    activity: [
      {
        name: 'initializeWizard',
        value: 'InitializeWizard',
      }, {
        name: 'saveSubAccount',
        value: 'SaveSubAccount',
      }, {
        name: 'closeWizard',
        value: 'CloseWizard',
      },
    ],
  }, {
    name: 'subAccountBar',
    value: 'HotelCenterSubAccountBar',
    setting: {},
    activity: [
      {
        name: 'loadSubAccountInfo',
        value: 'LoadSubAccountInfo',
      }, {
        name: 'saveSubAccountBid',
        value: 'SaveSubAccountBid',
      }, {
        name: 'saveBidMultiplier',
        value: 'SaveBidMultiplier',
      },
    ],
  }, {
    name: 'overViewPage',
    value: 'HotelCenterOverViewPage',
    setting: {},
    activity: [
      {
        name: 'loadHotelGroupGrid',
        value: 'LoadHotelGroupGrid',
      }, {
        name: 'loadHotelIdGrid',
        value: 'LoadHotelIdGrid',
      }, {
        name: 'loadDeviceTypeGrid',
        value: 'LoadDeviceTypeGrid',
      }, {
        name: 'loadDateGrid',
        value: 'LoadDateGrid',
      }, {
        name: 'loadLengthOfStayGrid',
        value: 'LoadLengthOfStayGrid',
      }, {
        name: 'loadUserCountryGrid',
        value: 'LoadUserCountryGrid',
      }, {
        name: 'loadHotelCountryGrid',
        value: 'LoadHotelCountryGrid',
      }, {
        name: 'loadSlotTypeGrid',
        value: 'LoadSlotTypeGrid',
      }, {
        name: 'loadAdvancedBookingGrid',
        value: 'LoadAdvancedBookingGrid',
      }, {
        name: 'loadCheckinDayGrid',
        value: 'LoadCheckinDayGrid',
      }, {
        name: 'loadDateTypeGrid',
        value: 'LoadDateTypeGrid',
      }, {
        name: 'loadSiteTypeGrid',
        value: 'LoadSiteTypeGrid',
      }, {
        name: 'loadSubAccountGrid',
        value: 'LoadSubAccountGrid',
      }, {
        name: 'bulkEditHotelBid',
        value: 'BulkEditHotelBid',
      }, {
        name: 'bulkEditHotelMultiplier',
        value: 'BulkEditHotelMultiplier',
      }, {
        name: 'bulkEditIncreaseDecreaseBid',
        value: 'BulkEditIncreaseDecreaseBid',
      }, {
        name: 'inlineEditHotelBid',
        value: 'InlineEditHotelBid',
      }, {
        name: 'inlineEditHotelMultiplier',
        value: 'InlineEditHotelMultiplier',
      },
    ],
  }, {
    name: 'budgetPage',
    value: 'HotelCenterBudgetPage',
    setting: {},
    activity: [
      {
        name: 'initializePage',
        value: 'InitializePage',
      }, {
        name: 'saveBidCap',
        value: 'SaveBidCap',
      }, {
        name: 'saveBudget',
        value: 'SaveBudget',
      },
    ],
  }, {
    name: 'utilityPage',
    value: 'HotelCenterUtilityPage',
    setting: {},
    activity: [
      {
        name: 'loadFeedStatusGrid',
        value: 'LoadFeedStatusGrid',
      }, {
        name: 'downloadFeedStatusReport',
        value: 'DownloadFeedStatusReport',
      },
    ],
  }],
};
